import React, {useEffect} from 'react';
import {browserHistory} from 'react-router';
import AuthStore from 'stores/AuthStore';
import UserSource from 'sources/UserSource';

interface AdminGumUserDeepLinkProps {
  routeParams: {globalUserId: string} | undefined;
}

const AdminGumUserDeepLink: React.FC<AdminGumUserDeepLinkProps> = (
  props: AdminGumUserDeepLinkProps
) => {
  const {user} = AuthStore.getState();
  const targetGlobalUserId = props.routeParams?.globalUserId;
  const tenantId = user.tenantId;

  useEffect(() => {
    UserSource.fetchGum(targetGlobalUserId)
      .then(u => {
        browserHistory.push(`/admin/users/edit/${u.userId}`);
      })
      .catch(e => {
        // Attempt to push the user back to a useful page, but also log the error
        console.error(e);
        browserHistory.push(`/admin/users`);
      });
  }, [targetGlobalUserId, tenantId]);
  return <></>;
};

export default AdminGumUserDeepLink;
